import InfoMyQuotes from './infoMyQuotes';

export default InfoMyQuotes;